export default __webpack_public_path__ + "static/media/minus.549af042.svg";